import * as React from "react";
import clsx from "clsx";
import sx from "./tabs.module.css";

const tabClasses =
	"px-1 py-4 w-auto flex items-center text-center text-gray-500 hover:text-gray-700 text-sm font-medium md:w-1/4";

export const TabLink: React.FC<
	React.PropsWithChildren<{
		href: string;
		target?: "_blank" | "self";
		className?: string;
	}>
> = ({ href, target, className, children }) => {
	return (
		<a
			href={href}
			target={target}
			rel={target === "_blank" ? "noopener noreferrer" : ""}
			className={clsx(sx.scrollItem, tabClasses, className)}
		>
			{children}
		</a>
	);
};

type TabButtonProps = {
	onClick: () => void;
	className?: string;
};

export const TabButton: React.FC<React.PropsWithChildren<TabButtonProps>> = ({
	onClick,
	className,
	children,
}) => {
	return (
		<button
			type="button"
			onClick={onClick}
			className={clsx(sx.scrollItem, tabClasses, className)}
		>
			{children}
		</button>
	);
};

export const Scroller: React.FC<React.PropsWithChildren<unknown>> = ({
	children,
}) => {
	return (
		<nav className={sx.scrollSnap} aria-label="Tabs">
			{children}
		</nav>
	);
};
